import React from "react";

export const SolidBackground = ({ bgColor = "#3E8DFF" }) => (
  <div className="absolute w-full h-full" style={{ backgroundColor: bgColor }} />
);
